import { createAsyncThunk } from '@reduxjs/toolkit';

export const LoadAnnouncements = createAsyncThunk(
    'announcements/loadAnnouncements',
    async (_, dispatch: any) => {
        const axios = dispatch.getState().core.axios;
        const response = await axios.get('api/Announcements/GetAllAnnouncements');
        return response;
    }
);
